(() => {
  if (window.__cBrandIntroInitialized) return;
  window.__cBrandIntroInitialized = true;
  const init = (root) => root.querySelectorAll('.c_brand-intro').forEach((section) => {
    const button = section.querySelector('.c_brand-intro__toggle');
    const text = section.querySelector('.c_brand-intro__text');
    if (!button || !text || button.dataset.initialized) return;
    button.dataset.initialized = 'true';
    const mq = window.matchMedia('(max-width: 740px)');
    const setExpanded = (expanded) => {
      button.setAttribute('aria-expanded', String(expanded));
      text.classList.toggle('is-expanded', expanded);
      button.querySelector('.c_brand-intro__toggle-label').textContent = expanded ? button.dataset.closeLabel : button.dataset.openLabel;
      button.querySelector('.c_brand-intro__toggle-icon').textContent = expanded ? '−' : '＋';
    };
    const update = () => {
      const overflowing = text.scrollHeight > 181;
      const enabled = mq.matches && overflowing;
      section.classList.toggle('c_brand-intro--has-toggle', enabled);
      button.hidden = !enabled;
      if (!enabled) setExpanded(false);
    };
    button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
    mq.addEventListener('change', update);
    if (typeof ResizeObserver !== 'undefined') new ResizeObserver(update).observe(text);
    if (document.fonts) document.fonts.ready.then(update);
    update();
  });
  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
